module.exports = __webpack_public_path__ + "static/media/faq-2.976e509c.png";